// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3PXNd","amount":"Amount_amount__3VKP7","tip":"Amount_tip__ARerA","tipHeader":"Amount_tipHeader__3Zeoj","tipsWrap":"Amount_tipsWrap__YfFTm"};